export default "__VITE_ASSET__Cb_j7ban__"